"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Copyright 2013-present, Novivia, Inc.
                    * All rights reserved.
                    */

var _SocialLogins = require("./SocialLogins");

var _SocialLogins2 = _interopRequireDefault(_SocialLogins);

var _utilities = require("@auex/utilities");

var _utilities2 = _interopRequireDefault(_utilities);

var _Button = require("react-bootstrap/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Form = require("react-bootstrap/Form");

var _Form2 = _interopRequireDefault(_Form);

var _FormControl = require("react-bootstrap/FormControl");

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormGroup = require("react-bootstrap/FormGroup");

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stringToReact = _utilities2.default.formats.stringToReact;

/**
 * Login form
 * @class
 */
var LoginForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LoginForm, _Component);

  function LoginForm() {
    (0, _classCallCheck3.default)(this, LoginForm);
    return (0, _possibleConstructorReturn3.default)(this, (LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginForm, [{
    key: "render",
    value: function render() {
      var __ = this.context.__;


      var queryString = "";

      if (this.props.urlToken) {
        queryString = "?t=" + this.props.urlToken;
      }

      return _react2.default.createElement(
        _Form2.default,
        {
          action: "/users/session" + queryString,
          className: "signin",
          method: "post",
          role: "form"
        },
        _react2.default.createElement("input", {
          name: "_csrf",
          type: "hidden",
          value: this.props.csrfToken
        }),
        _react2.default.createElement(
          _FormGroup2.default,
          null,
          _react2.default.createElement(_FormControl2.default, {
            "aria-label": __("contact::email"),
            name: "email",
            placeholder: __("contact::email"),
            type: "email",
            autoFocus: true,
            required: true
          })
        ),
        _react2.default.createElement(
          _FormGroup2.default,
          null,
          _react2.default.createElement(_FormControl2.default, {
            "aria-label": __("password::password"),
            name: "password",
            placeholder: __("password::password"),
            type: "password",
            required: true
          })
        ),
        _react2.default.createElement(
          _Button2.default,
          {
            bsSize: "large",
            bsStyle: "primary",
            type: "submit",
            block: true
          },
          __("login::header")
        ),
        _react2.default.createElement(
          "label",
          { className: "forgotpw" },
          _react2.default.createElement(
            "a",
            { href: "/" + __("routes::forgotpw") },
            __("password::forgotPw.header")
          )
        ),
        _react2.default.createElement(_SocialLogins2.default, {
          socialLogin: this.props.socialLogin,
          urlToken: this.props.urlToken
        }),
        this.props.registerLink ? _react2.default.createElement(
          "p",
          { className: "text-center" },
          stringToReact(__("login::noAccountRegister"), { registerLink: function registerLink(linkText) {
              return _react2.default.createElement(
                "a",
                { href: "/" + __("routes::signup") },
                linkText
              );
            } })
        ) : null
      );
    }
  }]);
  return LoginForm;
}(_react.Component), _class.propTypes = {
  // CSRF Token
  csrfToken: _propTypes2.default.string.isRequired,

  // Display the registration link at bottom of the form.
  registerLink: _propTypes2.default.bool,

  // Social login buttons to display
  socialLogin: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(["google", "facebook", "linkedin"])),

  // Token in url query string.
  urlToken: _propTypes2.default.string
}, _class.defaultProps = {
  socialLogin: ["google", "facebook", "linkedin"]
}, _class.contextTypes = {
  // Translation utility.
  __: _propTypes2.default.func.isRequired
}, _temp);
exports.default = LoginForm;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/react-components/LoginForm.jsx
// module id = 224
// module chunks = 9 10 11 15 18 19 23 65 66 68